import { useSelector } from 'react-redux';
import {
  isCommonAppLocalGameLaunchMode,
  isCasinoAppLocalGameLaunchMode,
} from '../redux/reducers/app/initialization';

export const useCommonAppStoreReviewMode = () => {
  return useSelector(isCommonAppLocalGameLaunchMode);
};

export const useCasinoAppStoreReviewMode = () => {
  return useSelector(isCasinoAppLocalGameLaunchMode);
};
